'use strict';

var dialog = require('./dialog'),
    product = require('./pages/product'),
    image = require('./pages/product/image'),
    variant = require('./pages/product/variant'),
    tealium = require('../../../int_tealium/cartridge/js/tealium/tealium'),
    util = require('./util'),
    _ = require('lodash');


var makeUrl = function (url, source, productListID) {

    if (url.indexOf('#') !== -1) {
        url = unHashUrl(url);
    }

    if (source) {
        url = util.appendParamToURL(url, 'source', source);
    }
    if (productListID) {
        url = util.appendParamToURL(url, 'productlistid', productListID);
    }

    return url;
};

var unHashUrl = function (url) {

    if (url.indexOf('?') !== -1) {
        url = url.replace(/#/g, '&');
    } else {
        url = url.replace(/#/, '?');
        url = url.replace(/#/g, '&');
    }

    return url;

};

var removeParam = function (url) {

    if (url.indexOf('?') !== -1) {
        return url.substring(0, url.indexOf('?'));
    } else {
        return url;
    }

};

var quickview = {

    init: function () {
        if (!this.exists()) {
            this.$container = $('<div/>').attr('id', 'QuickViewDialog').appendTo(document.body);
        }
        this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
            return $(thumbLink).attr('data-href');
        });

        image.replaceImages();
    },

    setup: function (qvUrl) {
        var $btnNext = $('.quickview-next'),
            $btnPrev = $('.quickview-prev');

        product.initializeEvents();

        this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
            return removeParam(url) === removeParam(qvUrl);
        });

        // hide the buttons on the compare page or when there are no other products
        if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
            $btnNext.hide();
            $btnPrev.hide();
            return;
        }

        if (this.productLinkIndex === this.productLinks.length - 1) {
            $btnNext.attr('disabled', 'disabled');
        }
        if (this.productLinkIndex === 0) {
            $btnPrev.attr('disabled', 'disabled');
        }

        $btnNext.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(1);
        }.bind(this));
        $btnPrev.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(-1);
        }.bind(this));
    },

    /**
     * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
     */
    navigateQuickview: function (step) {
        // default step to 0
        this.productLinkIndex += (step ? step : 0);
        var url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
        dialog.replace({
            url: url,
            callback: this.setup.bind(this, url)
        });
    },

    /**
     * @description show quick view dialog
     * @param {Object} options
     * @param {String} options.url - url of the product details
     * @param {String} options.source - source of the dialog to be appended to URL
     * @param {String} options.productlistid - to be appended to URL
     * @param {Function} options.callback - callback once the dialog is opened
     */
    show: function (options) {
        var url;
        if (!this.exists()) {
            this.init();
        }
        url = makeUrl(options.url, options.source, options.productlistid);
        var dialogWidth = 'auto';
        var dialogClassName = 'quick-view';
        if (options.productType == 'product-set'){
            dialogWidth = 'auto';
            dialogClassName = 'product-set-quickview quick-view';
        } else {
            dialogWidth = 'auto';
            dialogClassName = 'quick-view';

        }

        dialog.open({
            target: this.$container,
            url: url,
            options: {
                width: dialogWidth,
                dialogClass: dialogClassName,
                draggable: false,
                //title: Resources.QUICK_VIEW_POPUP,
                open: function () {
                    //this.setup(url);

                	/* PXSFCC-4495_WCAG_Modal_focus_management */
                	$(".ui-dialog").find(".ui-dialog-titlebar-close").on("mouseenter",function(){
                    	$(this).focus();
                    });
                    $(".ui-dialog").find(".ui-dialog-titlebar-close").trigger("mouseenter");

                    if ($('.product-variation-content').height() >= 466) {
                        $('.product-variation-content').slimScroll({
                            height: '465px',
                            railVisible: true,
                            color: '#f4f4f4',
                            railColor: '#ffffff',
                            railOpacity: 1,
                            size: '10px',
                            alwaysVisible: true
                        });
                    } else {
                    	$('.product-variation-content').addClass('max-height');
                    }
                    
                    
                    if ($('.product-set-list-sps').height() >= 466) {
                        $('.product-set-list-sps').slimScroll({
                            height: '465px',
                            railVisible: true,
                            color: '#f4f4f4',
                            railColor: '#ffffff',
                            railOpacity: 1,
                            size: '10px',
                            alwaysVisible: true
                        });
                        $('.product-set-list-sps').find('.qv-productset-scrollbar').slimScroll({destroy: true});
                    } else {
                    	$('.product-variation-content').addClass('max-height');
                    }
                    
                    util.updateselect();
                    product.initializeEvents();
                    
                    
                    //SM-6400 (Pre-select Color AND/OR Size on PDP when only 1 available)
                    var varAttributes = ['size', 'width', 'waist', 'length','braBandSize', 'braCupSize', 'shoeSize', 'shoeWidth'];
                    $(varAttributes).each(function() {
                    	var curr = this.toLowerCase();
                    	if ($('.swatches.'+curr+' li.selectable').length == 1) {
                    		$('.swatches.'+curr+' li.selectable:first .swatchanchor').trigger('click');
                        }	
        			});
                    
                    var $colorVariations = $('.swatches.color li.selected');
                    if ($colorVariations.length > 0) {
                    	var colorId=$colorVariations.data('swatchvalue');
                    	var productId=$('.product-variations').data('mpid');
                    	var $this=$('.swatches.color li.selected .swatchanchor');
                    	var url=$this.data('href');
                    	if(colorId && productId){
	                    	var colorVar='dwvar_'+productId+'_color';
	                    	url=util.removeParamFromURL(url, colorVar);
                            url=util.appendParamToURL(url, colorVar, colorId);
                            var urlQueryString = util.getQueryString(url);
                            if(urlQueryString.indexOf('source=') > -1){
                                var sourceVal = urlQueryString.slice(urlQueryString.indexOf('source=')).split('&')[0].split('=')[1];
                                url=util.removeParamFromURL(url, 'source');
                                url=util.appendParamToURL(url, 'source', sourceVal);
                            }
	                    	variant.updateContent(url);
                    	}
                    }
                    //tealium
                    var data = $('#pdpMain').data('productinfo');
                    data.product_viewtype = "quickshop";
          			data.event_name = 'quickshop'
                   if(document.URL.indexOf("q=") != -1){
                   		var searchClickData = $.extend(true, {}, data);
                    	searchClickData.event_name = 'search_results_click';
                    	tealium.triggerEvent(searchClickData);
                    }
                    tealium.triggerEvent(data);
                    
                    if (typeof options.callback === 'function') { options.callback(); }
                    if ($(this.$container).closest('.quick-view').find('span.ui-dialog-title').length > 0) {
                    	$(this.$container).closest('.quick-view').find('span.ui-dialog-title').remove();
                    }
                }.bind(this),
                close: function () {
                    $('body').find('.zoomWindowContainer, .zoomContainer').remove();
                }
            }
        });
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    }
};

module.exports = quickview;
